class FiltroActionTypes {
  static get SET_ONTEM() {
    return 'SET_ONTEM';
  }

  static get SET_HOJE() {
    return 'SET_HOJE';
  }

  static get SET_AMANHA() {
    return 'SET_AMANHA';
  }

  static get SET_DATE_PICKER() {
    return 'SET_DATE_PICKER';
  }

  static get CLEAR_FILTRO_DRAWER() {
    return 'CLEAR_FILTRO_DRAWER';
  }

  static get SET_FIELD_DRAWER() {
    return 'SET_FIELD_DRAWER';
  }

  static get FETCH_FILTRO_DATA() {
    return 'FETCH_FILTRO_DATA';
  }
}

export default FiltroActionTypes;
